export default {
   Accept: 'application/json',
   'X-Requested-With': 'XMLHttpRequest',
};